<script setup lang="ts">
import {Euro} from "@lucide/vue";

/**
 * The acts to bill at the end of a step, one line each as the server serves
 * them (code, amount, what it pays for). The pharmacist bills them in their
 * own software: this only reminds. Nothing shows when there is nothing to
 * bill. Where it sits — its borders, its indent — is the host's.
 */

defineProps<{
    lines?: string[] | null;
}>();
</script>

<template>
  <div
    v-if="lines?.length"
    class="flex items-center gap-3 px-4 py-3 bg-muted"
  >
    <span class="w-9 h-9 shrink-0 rounded-full bg-primary text-white flex items-center justify-center">
      <Euro class="w-4 h-4" />
    </span>
    <span class="flex flex-col">
      <span class="text-sm font-semibold text-primary">
        Rappel facturation
        <span class="font-normal text-muted-foreground">· à facturer maintenant</span>
      </span>
      <span
        v-for="line in lines"
        :key="line"
        class="text-sm text-muted-foreground"
      >{{ line }}</span>
    </span>
  </div>
</template>
